import { render, staticRenderFns } from "./ReceiveManage.vue?vue&type=template&id=17385caa&scoped=true&"
import script from "./ReceiveManage.vue?vue&type=script&lang=js&"
export * from "./ReceiveManage.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveManage.vue?vue&type=style&index=0&id=17385caa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17385caa",
  null
  
)

export default component.exports